export function isMultipleOf(a: number, b: number) {
  return a % b === 0;
}

/**
 * Clamp a number between min and max inclusive
 */
export function clamp(min: number, max: number, input: number): number {
  return Math.max(min, Math.min(max, input))
}
